export const MAX_OFFSET = 10;

export const SAVI_BRAND_NAME = 'Savi';

export const SAVI_RECOMMENDATIONS = 'Recommendations';
